import Model from './Model';
import Order from './Order';
import Customer from './Customer';

import moment from 'moment';

export default class Lead extends Model {
    resource () {
        return 'leads';
    }

    get mutations() {
        return {
            customer: Customer,
            order: Order,
        };
    }

    /**
     * Get the related customer
     *
     * @returns {*}
     */
    customer() {
        return this.hasOne(Customer);
    }

    /**
     * Get the related order
     *
     * @returns {*}
     */
    order() {
        return this.hasOne(Order);
    }

    /**
     * Mark the lead as do not print
     *
     * @returns {Promise<*>}
     */
    markDoNotPrint() {
        this.do_not_print = true;
        this.status = 'do-not-print';

        return this.save();
    }
    markIgnored() {
        this.do_not_print = true;
        this.status = 'ignore-print';

        return this.save();
    }

    /**
     * Mark the lead as do print
     *
     * @returns {Promise<*>}
     */
    markReadyToPrint() {
        this.do_not_print = false;
        this.status = 'ready';

        return this.save();
    }

    /**
     * Mark the lead as do print
     *
     * @returns {Promise<*>}
     */
    markForReveiwMultipleLeads() {
        this.do_not_print = false;
        this.status = 'review';
        this.review_reason = 'multiple-leads';
        return this.save();
    }

    /**
     * Mark the lead as failed
     *
     * @returns {Promise<*>}
     */
    markFailed() {
        this.status = 'failed';

        return this.save();
    }

    /**
     * Mark the lead as printed
     *
     * @returns {Promise<*>}
     */
    markPrinted() {
        this.printed_at = moment();
        this.status = 'printed';

        return this.save();
    }
}
